import { render } from "./Checklist.vue?vue&type=template&id=448b872d&scoped=true"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"

import "./Checklist.vue?vue&type=style&index=0&id=448b872d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448b872d"]])

export default __exports__